import { render, staticRenderFns } from "./Tztj.vue?vue&type=template&id=64656557&"
import script from "./Tztj.vue?vue&type=script&lang=js&"
export * from "./Tztj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports